// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2a8EJ","has-secondary-button":"_37a2v","hasSecondaryButton":"_37a2v","gap":"_3hDS3"};